import { render, staticRenderFns } from "./zhaopinxiangqing.vue?vue&type=template&id=28cf7372&scoped=true&"
import script from "./zhaopinxiangqing.vue?vue&type=script&lang=js&"
export * from "./zhaopinxiangqing.vue?vue&type=script&lang=js&"
import style0 from "./zhaopinxiangqing.vue?vue&type=style&index=0&id=28cf7372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf7372",
  null
  
)

export default component.exports